module.exports = __webpack_public_path__ + "img/modal-left-4.1e6abcb5.png";